import { combineReducers } from "redux";
import authReducer from "./auth.reducer";
import clientReducer from "./client.reducer";
import campaignReducer from "./campaign.reducer";
import promoReducer from "./promocode.reducer";
import binReducer from "./bin.reducer";
import alertReducer from "./alert.reducer";
import userReducer from "./user.reducer";
import campaignBannerReducer from "./campaignmanager.reducer";
import addCampaignReducer from "./addCampaigndata.reducer";
import aiDataReducer from "./aiData.reducer";
import employeeReducer from "./staticData";
import { blogsReducer } from "./blog.reducer";
import { categoryReducer } from "./categories.reducer";
import { mediaReducer } from "./media.reducer";

export default combineReducers({
  authReducer,
  userReducer,
  alertReducer,
  clientReducer,
  campaignReducer,
  promoReducer,
  binReducer,
  campaignBannerReducer,
  addCampaignReducer,
  aiDataReducer,
  employeeReducer,
  blogsReducer,
  categoryReducer,
  mediaReducer
});
